"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
function Dashboard() {
    return (react_1.default.createElement(AppLayout_1.default, { title: "Dashboard", renderHeader: function () { return (react_1.default.createElement("h2", { className: "header" }, "Dashboard")); } }));
}
exports.default = Dashboard;
